import { Oval } from 'react-loading-icons'
import { Portal } from 'react-portal';
import { useApp } from "context";

const LoadingSpinner = () => {
  const { loading } = useApp();

  if (loading) {
    return(
      <Portal>
        <div style={{ position: 'fixed', left: 0, top: 0, width: '100vw', height: '100vh', background: 'rgba(0,0,0,.45)', zIndex: 10010000 }} className='jc-ac'>
          <Oval stroke="#5c7d6d" fill="#5c7d6d" strokeWidth={6} />
        </div>
      </Portal>
    )
  } else {
    return null;
  }
};

export default LoadingSpinner;
